<template>
    <div :class="['BaseDropdown__container',className]">
        <i v-if="icon" :class="['BaseDropdown__icon',icon]"></i>
        <div class="BaseDropdown" v-bind:class="{'BaseDropdown_error':(errors && errors.length>0)}">
            <label class="BaseDropdown__label" v-once>
                {{translate(label)}}
            </label>
            <select class="BaseDropdown__select" @change="change($event)" :value="value">
                <option class="BaseDropdown__option" v-for="item in items" :key="item.id" :value="item.id">
                    {{ translate(item.name) }}
                </option>
            </select>
            <BaseErrors :errors="errors"/>
        </div>
    </div>
</template>

<script>
    import BaseErrors from './BaseErrors.vue';

    export default {
        name: 'BaseDropdown',
        components: {
            BaseErrors
        },
        props: {
            //Label above dropdown
            label: {
                type: String,
                required: true
            },
            //Input value of dropdown (id of selected value)
            value: {
                type: String,
            },
            //Collection of objects with 'id' and 'name' to show in dropdown
            items: {
                type: Array,
                required: true
            },
            //Form validation errors
            errors: {
                type: Array
            },
            //Additional css class name for styling
            className: {
                type: String
            },
            //Icon class
            icon: {
                type: String
            }
        },
        methods: {
            change: function (e) {
                this.$emit('change', e);
            }
        }
    };
</script>

<style>
    .BaseDropdown__container {
        display: flex;
        flex-direction: row;
        margin: 10px 0;
    }

    .BaseDropdown__icon {
        color: rgba(96, 125, 139, 0.7);
        font-size: 24px;
        margin: 4px 8px 0 4px;
    }

    .BaseDropdown__select {
        font-family: Roboto,sans-serif;
        background-color: transparent;
        width: 100%;
        padding: 8px 24px 4px 0px;
        font-size: 16px;
        border: none;
        border-bottom: 1px solid rgba(96, 125, 139, 0.4);
    }

    .BaseDropdown_error .BaseDropdown__select {
        border-bottom: 1px solid #cc4a4a;
    }

    /* Remove focus */
    .BaseDropdown__select:focus {
        outline: none;
    }

    .BaseDropdown__label {
        top: -12px;
        font-size: 14px;
        position: absolute;
        color: rgba(96, 125, 139,0.7);
    }

    .BaseDropdown__select {
        appearance: none;
    }

    .BaseDropdown {
        position: relative;
        width: 100%;
    }

        .BaseDropdown:after {
            position: absolute;
            top: 1em;
            right: .5em;
            width: 0;
            height: 0;
            padding: 0;
            content: "";
            border-left: .25em solid transparent;
            border-right: .25em solid transparent;
            border-top: .375em solid rgba(96, 125, 139, 0.7);
            pointer-events: none
        }

    .BaseDropdown__option {
        color: #000
    }

</style>



// WEBPACK FOOTER //
// BaseDropdown.vue?6c7a5a8d